import { useEffect, useState } from "react";
import { CheckCheck, Check, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { PageHeader, Panel, DataTable, EmptyState, SkeletonPage, btn } from "@/components/common";
import { toast } from "sonner";

export default function Approvals() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/manager/relationships/pending").then((r) => setRows(r.data)).catch((e) => { toast.error(errMsg(e)); setRows([]); });
  useEffect(() => { load(); }, []);
  const decide = async (id, approve) => {
    try {
      if (approve) await api.post(`/manager/relationships/${id}/approve`); else await api.delete(`/manager/relationships/${id}`);
      toast.success(approve ? "Reporting line approved" : "Request declined");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!rows) return <SkeletonPage kpis={0} rows={4} cols={4} />;
  return (
    <div data-testid="approvals-page">
      <PageHeader crumbs={[{ label: "My Team", to: "/team" }, { label: "Approvals" }]} title="Approvals"
        subtitle="Reporting lines a manager added by hand. Approving one lets that manager see the employee's training." />
      <Panel title={`Pending reporting lines${rows.length ? ` (${rows.length})` : ""}`}>
        <DataTable testId="approvals-table" rows={rows}
          emptyState={<EmptyState icon={CheckCheck} title="Nothing waiting for you" hint="Reporting lines that come from Microsoft Entra are applied automatically. Only manually added ones need approval, and there are none right now." />}
          mobileCard={(r) => (
            <div className="space-y-1.5">
              <div className="text-sm font-medium">{r.employee?.displayName}</div>
              <div className="text-xs text-slate-500">Manager: {r.manager?.displayName} · {fmtDateTime(r.createdAt)}</div>
              <div className="flex gap-1.5 pt-1">
                <button onClick={() => decide(r.id, true)} className={btn.primary} data-testid={`approve-rel-${r.id}`}><Check size={13} /> Approve</button>
                <button onClick={() => decide(r.id, false)} className={btn.secondary} data-testid={`reject-rel-${r.id}`}><X size={13} /> Decline</button>
              </div>
            </div>)}
          columns={[
            { key: "employee", label: "Employee", render: (r) => <span className="font-medium">{r.employee?.displayName}</span> },
            { key: "manager", label: "Would report to", render: (r) => r.manager?.displayName },
            { key: "createdAt", label: "Requested", render: (r) => fmtDateTime(r.createdAt) },
            { key: "x", label: "", width: 190, render: (r) => (
              <div className="flex gap-1">
                <button onClick={() => decide(r.id, true)} className={btn.small} data-testid={`approve-rel-${r.id}`}><Check size={11} /> Approve</button>
                <button onClick={() => decide(r.id, false)} className={btn.small} data-testid={`reject-rel-${r.id}`}><X size={11} /> Decline</button>
              </div>) },
          ]} />
      </Panel>
    </div>
  );
}
